import { Controller } from "@hotwired/stimulus";
import { useDebounce } from "stimulus-use";
import Plyr from "plyr";

export default class extends Controller {
  static targets = ["responsiveVideo", "video"];
  static debounces = ["handleResponsiveVideos"];

  connect() {
    useDebounce(this, { wait: 500 });
  }
  initialize() {
    const videos = this.videoTargets || [];

    videos.forEach((video) => {
      const { config } = video.dataset;
      let _config = {};
      if (config) {
        _config = JSON.parse(config);
      }

      const player = new Plyr(video, _config);

      player.on("playing", () => {
        const poster = document.querySelector("[data-plyr-poster]");
        poster?.classList.remove("video-block__poster--active");
      });
    });

    const width = window.innerWidth;

    this.handleResponsiveVideos();

    window.addEventListener("resize", () => {
      width !== window.innerWidth && this.handleResponsiveVideos();
    });
  }

  addSourceToVideo = (elem, src) => {
    const types = ["video/mp4", "video/webm"];

    if (elem.innerHTML !== "") {
      elem.innerHTML = "";
    }

    types.forEach((type) => {
      const source = document.createElement("source");
      source.src = src;
      source.type = type;

      elem.appendChild(source);
    });
  };

  determineVideo = (elem) => {
    if (window.innerWidth < 768) {
      this.addSourceToVideo(
        elem,
        elem.dataset.mobileVideo || elem.dataset.desktopVideo
      );
    } else {
      this.addSourceToVideo(elem, elem.dataset.desktopVideo);
    }
  };

  handleResponsiveVideos = () => {
    this.responsiveVideoTargets?.forEach((video) => {
      this.determineVideo(video);
    });
  };
}
